// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main." + {"18":"97aa0d5e2d1e5e7a0804","31":"eddad15a3d70079a21c8","32":"2907b3e72f590aa49a01","333":"7602b1fcb86998c6f3a5"}[chunkId] + ".css";
};